import React from "react";
import { Skeleton, } from "@mui/material";

export const SkeletonDigitalWallet = ({ height, radius = '10px' }) => {
	return (

		<Skeleton
			variant="rectangular"
			height={height}
			sx={{
				borderRadius: radius,
				mb: '2px',
			}}
		/>
	);
};
